import React from 'react';
import { gridFatherSX } from '@/components/blocks/DpLibrary/DpCardIconInformationGrid/style/main';
import { Grid, SxProps } from '@mui/material';
import { combineSX } from '@/utils/combineSX';

export const DpCardIconInformationGrid = ({
	children,
	sx,
	...props
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => {
	const cleanChildren = React.Children.toArray(children).filter((child) =>
		React.isValidElement(child)
	);

	return (
		<Grid container sx={combineSX([gridFatherSX, ...(Array.isArray(sx) ? sx : [sx])])} {...props}>
			{cleanChildren}
		</Grid>
	);
};
